import { errorValidation } from './utils';

(() => {
    const $form = $("form[name='recover']");
    $form.validate({
        ignore: [],
        ...errorValidation,
        errorClass: 'form__error',
        rules: {
            'recover[email]': {
                required: true,
                email: true,
            },
        },
        messages: {
            'recover[email]': {
                required: window.translations.required,
                email: window.translations.emailInvalid,
            },
        },
        submitHandler: (form) => {
            form.submit();
        },
        success: function (label) {
            let name = label.attr('for');
            label.text('');
        },
    });
})();
